const apidomain = "http://buid.jc881.com"; // 测试域名
// AJAX请求对象
export default { apidomain: apidomain };
